import type { FinancialCalendarEvent } from '@/entities/financial-calendar';

import { eventReleaseBadge } from '../model/utils';

/**
 * TRAD-2899 — 발표 상태 배지(«발표완료 / 일정 변동 가능 / 알 수 없음»). 목록 카드·상세 패널·상세 드로어가 같은 컴포넌트를 쓴다
 * (iOS 45ba3c6d 처럼 상세에도 배지 — 팀장 결정 2026-10-07). 규격은 종전 카드 «발표완료» 배지 그대로(중립색 테두리).
 * 문구 판정은 `eventReleaseBadge`(필드 없음 = 종전 confirmed / SCHEDULED = 없음 / 미지값 = 알 수 없음).
 */
export const ReleaseBadge = ({ event }: { event: Pick<FinancialCalendarEvent, 'confirmed' | 'releaseStatus'> }) => {
  const label = eventReleaseBadge(event);
  if (label === null) return null;
  return (
    <span data-testid="release-badge" className="text-2xs text-muted-foreground border border-border rounded-full px-1.5">
      {label}
    </span>
  );
};
